import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';
export default createStore({
  state: {
    // todo 这个一定要注意配置
    // project: 'rez',
    // project: "mate",
    // project: "xyy",
    // project: 'xsg',
    // project: 'jyd',
    project: 'pd',
    token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
    auth: <any>{
      user: {
        id: null,
        avatarId: null,
        name: null,
        account: null,
        password: null,
        email: null,
        phone: null,
      },
      perms: null,
      roles: null,
    },
    ws: {
      connectStatus: false,
    },
    wxWs: {
      connectStatus: false,
    },
    esucard: {
      ready2rollMs: 5000,
    },
    isMobile: false, // 添加移动端状态
    windowWidth: window.innerWidth, // 添加窗口宽度跟踪
  },
  getters: {
    getUser(state) {
      return state.auth.user;
    },
    getWS(state) {
      return state.ws;
    },
    getWSConnectStatus(state) {
      return state.ws.connectStatus;
    },
    getWxWS(state) {
      return state.wxWs;
    },
    getWxWSConnectStatus(state) {
      return state.wxWs.connectStatus;
    },
    //此项目的类型，根据项目前缀改变
    projectType: (state) => {
      const mapping = {
        rez: "rez",
        mate: "mate",
        xyy: "mate",
        xsg: "rez",
        jyd: "rez",
        pd: "mate",
      };
      return mapping[state.project as keyof typeof mapping] || "rez";
    },
    shopDesc(state, getters) {
      const projectType = getters.projectType;
      if (projectType === "mate") {
        return "团队";
      } else {
        return "门店";
      }
    },
    roomDesc(state, getters) {
      const projectType = getters.projectType;
      if (projectType === "mate") {
        return "员工";
      } else {
        return "房间";
      }
    },
    isMobile: (state) => state.isMobile,
    windowWidth: (state) => state.windowWidth,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token); //存储token
    },
    delToken(state) {
      state.token = "";
      localStorage.removeItem("token"); //删除token
    },
    setAuth(state, auth) {
      state.auth = auth;
    },
    delAuth(state) {
      state.auth.user = {
        id: null,
        avatarId: null,
        name: null,
        account: null,
        password: null,
        email: null,
        phone: null,
      };
      state.auth.perms = null;
      state.auth.roles = null;
    },
    setWS(state, ws) {
      state.ws = ws;
    },
    delWS(state) {
      state.ws.connectStatus = true;
    },
    setWSConnectStatus(state, connectStatus) {
      state.ws.connectStatus = connectStatus;
    },
    setWxWS(state, ws) {
      state.wxWs = ws;
    },
    delWxWS(state) {
      state.wxWs.connectStatus = true;
    },
    setWxWSConnectStatus(state, connectStatus) {
      state.wxWs.connectStatus = connectStatus;
    },
    SET_IS_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    },
    SET_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
      state.isMobile = width <= 768; // 自动更新isMobile状态
    },
  },
  actions: {
    initWindowListener({ commit }) {
      const handleResize = () => {
        commit("SET_WINDOW_WIDTH", window.innerWidth);
      };
      // 初始设置
      handleResize();
      // 添加监听
      window.addEventListener("resize", handleResize);
      // 返回清理函数
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
